import type { Candle } from "../types";
import type { Swings } from "./SwingEngine";
import type { StructureEvent } from "./types";

export interface BOSResult { events: StructureEvent[]; trend: "up" | "down" | null }

// Break of Structure / Change of Character: a close through the most recent confirmed swing.
// Break WITH the prevailing trend = BOS; break AGAINST it = CHoCH.
export const BOSEngine = {
  detect(candles: Candle[], swings: Swings, lookback: number): BOSResult {
    const { highs, lows } = swings;
    const events: StructureEvent[] = [];
    let trend: "up" | "down" | null = null;
    let hi: (typeof highs)[number] | null = null, lo: (typeof lows)[number] | null = null;
    let hiBroken = false, loBroken = false;
    let hIdx = 0, lIdx = 0;
    for (let i = 0; i < candles.length; i++) {
      while (hIdx < highs.length && highs[hIdx].index <= i - lookback) { hi = highs[hIdx]; hiBroken = false; hIdx++; }
      while (lIdx < lows.length && lows[lIdx].index <= i - lookback) { lo = lows[lIdx]; loBroken = false; lIdx++; }
      const close = candles[i].close;
      if (hi && !hiBroken && close > hi.price) {
        hiBroken = true;
        events.push({ index: i, from: hi.index, price: hi.price, dir: "bull", type: trend === "down" ? "CHoCH" : "BOS", time: candles[i].time });
        trend = "up";
      }
      if (lo && !loBroken && close < lo.price) {
        loBroken = true;
        events.push({ index: i, from: lo.index, price: lo.price, dir: "bear", type: trend === "up" ? "CHoCH" : "BOS", time: candles[i].time });
        trend = "down";
      }
    }
    return { events, trend };
  },
};
